// ════════════════════════════════════════════════════════════
//  words.js — Willie's script and the sign gags, built from text.json
// ════════════════════════════════════════════════════════════
//  No JSX in here on purpose, so tools/text-check.mjs can run it in plain Node
//  and prove it still says exactly what the old hard-coded versions said.
//  ringside.js re-exports these under the names the game already uses.
// ════════════════════════════════════════════════════════════
import { say, fmt, listOf } from "./text.js";

// one beat every BEAT seconds. `cue` steers Willie (A / B turn him to a corner,
// "welcome" cheers); any other cue is just a line said straight ahead.
export const SCRIPT = listOf("willie.script", 1).map((b) => ({
  cue: (b && b.cue) || "say",
  line: (n) => fmt(b && b.text != null ? b.text : "", { A: n && n.A, B: n && n.B }),
}));
export const FINAL_LINES = { 10: say("willie.final.10"), 3: say("willie.final.3"), 2: say("willie.final.2"), 1: say("willie.final.1") };
export const finalLine = (n) => FINAL_LINES[n] || say("willie.final.other", { n });
export const HANDOFF_LINE = say("willie.handoff");
export const CORNER_NAMES = { A: say("willie.corner.A"), B: say("willie.corner.B") };
export const SIGN_GAGS = listOf("signs.gags");
